<template>
  <el-dialog
    title="嵌入"
    :visible.sync="mIsShow"
    append-to-body
    width="592px"
    height="500px">
    <span>
      <label>貼文網址</label>
      <el-input v-model="url" @input="onInput" placeholder="請輸入貼文網址或貼文ID或嵌入網址" />

      <label style="margin-top: 12px;display: block;">貼文時間</label>
      <el-date-picker
        v-model="datetime"
        type="datetime"
        placeholder="請輸入貼文在FB發佈的時間"
        class="w-100"
        style="width: 100%;">
      </el-date-picker>
      <iframe
        v-if="mIsShow && previewingPostID"
        :src="`https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3D${previewingPostID}%26id%3D${fansPageID}`"
        width="100%"
        height="600"
        style="border:none;overflow:hidden;margin-top: 12px;"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media">
      </iframe>
    </span>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit" :disabled="!previewingPostID">確定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import FBFansPagePostLinkParser from '@/utils/fb/FBFansPagePostLinkParser.js'

export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    fansPageID: {
      type: String,
      required: true
    },
    fansPageNumID: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      mIsShow: false,
      previewingPostID: null,
      url: '',
      datetime: new Date()
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    onInput () {
      this.previewingPostID = FBFansPagePostLinkParser.parse(this.url)
    },
    submit () {
      this.$emit('submit', {
        id: this.previewingPostID,
        dt: this.datetime
      })
      this.previewingPostID = null
      this.url = ''
      this.$emit('close')
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
    }
  }
}
</script>
